import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconCloseStyle0 = gravityIconIndividualCss;

const GravityIconClose = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'ceaf08bcc316d8a732c29f83ce831c40e0051100', color: this.color, size: this.size }, h("svg", { key: '8f8592cfb3a077265942b51e3fb15dfbac933568', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '29316cf5eb5b62394a908edaeb7b673dc3d19e63', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.773 14.712 12.061 11l3.712-3.712a.5.5 0 0 0 0-.707l-.354-.354a.5.5 0 0 0-.707 0L11 9.939 7.288 6.227a.5.5 0 0 0-.707 0l-.354.354a.5.5 0 0 0 0 .707L9.939 11l-3.712 3.712a.5.5 0 0 0 0 .707l.354.354a.5.5 0 0 0 .707 0L11 12.061l3.712 3.712a.5.5 0 0 0 .707 0l.354-.354a.5.5 0 0 0 0-.707Z", fill: "currentColor" }))));
    }
};
GravityIconClose.style = GravityIconCloseStyle0;

export { GravityIconClose as gravity_icon_close };

//# sourceMappingURL=gravity-icon-close.entry.js.map